import { useIntl } from 'react-intl'
import useCurrentProviderType from './currentProviderType'

export const useProviderRiskLabel = () => {
  const { formatMessage } = useIntl()
  const providerType = useCurrentProviderType()

  return formatMessage({ id: `navbar.providerRisk.${providerType}` })
}
